import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, Router, ActivatedRoute, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { CookieService } from 'ngx-cookie-service';

declare var $: any;
@Injectable({
    providedIn: 'root'
})
export class AuthGuardResolve implements Resolve<any> {
    constructor(private router: Router,
        private property: PropertiesService,
        private http: HttpClient,
        private alert: AlertDialogService,
        private _router: Router,
        private Cookie: CookieService,
    ) { }

    resolve(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        console.log(next);
        
        if (!sessionStorage.getItem('UserId') || sessionStorage.getItem('UserId') == null || sessionStorage.getItem('UserId') == '' || sessionStorage.getItem('UserId') == ""){
            this.alert.openSnackBar('Session Expired','2');
            sessionStorage.clear();
            this.router.navigate(["/login"]);
        }
        // if (next.data.title == null || next.data.title == '' || next.data.title == "") {
        //     // $(".tool-title").text('FREIGHT FORWARDING');
        // } else {
        //     // $(".tool-title").text('FREIGHT FORWARDING - ' + next.data.title);
        // }
        // if(this.Cookie.get('projectUserName') == 'admin' && this.Cookie.get('projectUserPassword') == 'admin'){

        // }else{
        //     this.homeRedirect();
        // }
        // return 'Not Okey';
        // return new Promise((resolve, reject) => {
        //     this.authGuard.canActivate().then((response: any) => {
        //         this.http.get(this.property.ipAndPort.concat(this.property.BSSAPI) + "/privilege/button",
        //             { params: { ouId: this.property.ouId.toString(), userId: this.property.userId, roleId: this.property.roleId, link: next.url[0].path } }).subscribe((res: any) => {
        //                 if (res.status == 200) {
        //                     this.property.allowSaveButton = res.result.save;
        //                     this.property.allowEditButton = res.result.edit;
        //                     this.property.allowCancelButton = res.result.cancel;
        //                     this.property.allowPrintButton = res.result.print;
        //                     this.property.allowSendEmailButton = res.result.email;
        //                     resolve(true)
        //                 } else {
        //                     sessionStorage.clear();
        //                     resolve(false)
        //                     this.authService.logOut();
        //                 }
        //             }, (error) => {
        //                 reject(error);
        //                 this.alert.openSnackBar("ERROR.", error.message);
        //                 sessionStorage.clear();
        //                 this.authService.logOut();
        //             });

        //     });
        // });
    }
    homeRedirect() {
        sessionStorage.clear();
        this.Cookie.deleteAll();
        this._router.navigate(["login"]);
    }

}